import { render, staticRenderFns } from "./folderModificationComponent.vue?vue&type=template&id=2aad6695&"
import script from "./folderModificationComponent.vue?vue&type=script&lang=js&"
export * from "./folderModificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports